import { useNuxtApp } from "#imports";
import { createSupabaseClient } from "../utils/client.mjs";
export const useSupabaseAuthClient = () => {
  const nuxtApp = useNuxtApp();
  if (!nuxtApp._supabaseAuthClient) {
    nuxtApp._supabaseAuthClient = createSupabaseClient();
  }
  return nuxtApp._supabaseAuthClient;
};
